module.exports = "<div class=\"text-center login__text mb20 login__success-title\">\n    <strong class=\"block\" translate=\"reset_success_title\"></strong>\n    <span class=\"block\" translate=\"reset_success_description\"></span>\n</div>\n<a ui-sref=\"account.login\" class=\"btn-block login__btn mb32\" translate=\"return_to_login\"></a>";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/account/components/resetSuccess/resetSuccess.html
// module id = 707
// module chunks = 0